import Enum from "../../../enums/Enum";

const EnumTemperature = new Enum({
    HOT: "Hot",
    COLD: "Cold"
});

export default EnumTemperature;